var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url
    ? _c("div", { staticClass: "trbo-a-image" }, [
        _c("img", {
          staticClass: "trbo-a-image__media",
          attrs: { src: _vm.url, alt: _vm.altText },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }